import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { getForm } from "../api";
import { Button } from "./components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const HtmlContent = styled.div`
  margin-bottom: 16px;
`;

const ConsentBox = styled.div`
  border: 1px solid #ccc;
  background-color: #f9f9f9;
  padding: 16px;
  margin-bottom: 16px;
  width: 100%;
`;

const ConsentCheckbox = styled.label`
  display: flex;
  align-items: center;
`;

const CheckboxInput = styled.input`
  margin-right: 8px;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

interface ConsentProps {
  onPrevious: () => void;
  onContinue: () => void;
}

const formData = {
  consent: "",
  consentQuestion: "",
};

const Consent: React.FC<ConsentProps> = ({ onPrevious, onContinue }) => {
  const [agreed, setAgreed] = useState(false);
  const [engage, setEngaged] = useState(false);
  const [htmlContent, setHtmlContent] = useState(formData.consent);
  const [consentQuestion, setConsentQuestion] = useState(
    formData.consentQuestion
  );

  useEffect(() => {
    getForm("consent").then(({ content }) => {
      formData.consent = content;
      setHtmlContent(content);
    });
    getForm("consentQuestion").then(({ content }) => {
      formData.consentQuestion = consentQuestion;
      setConsentQuestion(content);
    });
  }, [consentQuestion]);

  const html = React.useMemo(() => ({ __html: htmlContent }), [htmlContent]);
  const question = React.useMemo(
    () => ({ __html: consentQuestion }),
    [consentQuestion]
  );

  const handleAgreed = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAgreed(e.target.checked);
  };

  const handleEngage = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEngaged(e.target.checked);
  };

  const handleContinue = () => {
    if (agreed && engage) {
      onContinue();
    }
  };

  return (
    <Container>
      <HtmlContent dangerouslySetInnerHTML={html} />
      <ConsentBox>
        <div dangerouslySetInnerHTML={question} />
        <ConsentCheckbox>
          <CheckboxInput
            type="checkbox"
            checked={agreed}
            onChange={handleAgreed}
            required
          />
          Oui, je suis conscient des conditions et je les accepte sans réserve.
        </ConsentCheckbox>
        <ConsentCheckbox>
          <CheckboxInput
            type="checkbox"
            checked={engage}
            onChange={handleEngage}
            required
          />
          J'atteste sur l'honneur être éligible à <a href="https://www.legifrance.gouv.fr/codes/section_lc/LEGITEXT000006069414/LEGISCTA000019989918/2009-09-23">l'exception au droit d'auteur</a>
        </ConsentCheckbox>
      </ConsentBox>
      <ButtonContainer>
        <Button color="negative" onClick={onPrevious}>
          Précédent
        </Button>
        <Button disabled={!agreed || !engage} onClick={handleContinue}>
          Continuer
        </Button>
      </ButtonContainer>
    </Container>
  );
};

export default Consent;
